export const COHORTS = {
	NOT_ENROLLED: 'not_enrolled',
	CONTROL: 'control',
	TREATMENT: 'treatment',
} as const;

export type CohortValues = (typeof COHORTS)[keyof typeof COHORTS];

export const CCP = 'CCP';
export const HAMS = 'HAMS';
export type BillingSourceSystem = typeof CCP | typeof HAMS;

export const FEATURE_LIST_ACTION_SUBJECT_ID = 'editionAwarenessFeature';
export const FEATURE = 'editionAwarenessDropdown';
